var _defs, _polygon, _rect, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _polygon7, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNexgen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2490 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_154-2);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_154-4);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_154);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_154-5);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_154-6);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_154-3);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 154",
    x1: 879.87,
    y1: 90.92,
    x2: 879.87,
    y2: 701.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c00d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 154",
    x1: 1922.25,
    y1: 90.92,
    x2: 1922.25,
    y2: 701.42,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 154",
    x1: 174.29,
    y1: 90.92,
    x2: 174.29,
    y2: 701.42,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154-4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 154",
    x1: 587.31,
    y1: 90.92,
    x2: 587.31,
    y2: 701.42,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154-5",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 154",
    x1: 1515.24,
    y1: 90.92,
    x2: 1515.24,
    y2: 701.42,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154-6",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 154",
    x1: 2315.1,
    y1: 90.92,
    x2: 2315.1,
    y2: 701.42,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_154"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1001.34 246.58 952.22 296.37 859.21 390.67 758.4 390.67 898.79 248.78 765.48 112.02 865.18 112.02 954.31 200.1 1001.34 246.58"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1774.58,
    y: 112.02,
    width: 288.25,
    height: 70.15
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2069.92 326.66 2069.92 390.67 1774.58 390.67 1774.58 223.86 2039.41 223.86 2039.41 274.41 1862.33 274.41 1862.33 326.66 2069.92 326.66"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "262.02 281.06 72.4 112 -.61 112 -.61 390.67 86.57 390.67 86.57 221.61 276.18 390.67 349.2 390.67 349.2 112 262.02 112 262.02 281.06"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "527.37 282.07 704.45 282.07 704.45 231.51 527.37 231.51 527.37 182.15 727.88 182.15 727.88 112 439.64 112 439.64 390.67 734.97 390.67 734.97 326.65 527.37 326.65 527.37 282.07"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1134.37 112.02 1001.34 246.58 954.31 200.1 1039.02 112.02 1134.37 112.02"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1143.63 390.67 1041.72 390.67 952.22 296.37 1001.34 246.58 1143.63 390.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1454.49,186.85c11.07-7.96,24.25-14.13,39.5-18.51,15.26-4.38,31.96-6.57,50.13-6.57,19.62,0,37.6,2.59,53.94,7.76,16.35,5.17,31.6,13.2,45.77,24.08l56.12-38.22c-18.53-15.66-41.33-27.6-68.38-35.83-27.07-8.22-57.49-12.34-91.27-12.34-30.51,0-58.49,3.52-83.91,10.55-25.43,7.04-47.59,17.06-66.47,30.06-18.89,13.01-33.51,28.26-43.86,45.78-10.35,17.51-15.53,36.76-15.53,57.72s5.18,40.21,15.53,57.72c10.35,17.52,24.79,32.78,43.32,45.78,18.53,13.01,40.5,23.03,65.93,30.06,25.42,7.03,53.21,10.55,83.37,10.55,27.24,0,54.49-2.99,81.73-8.96,27.24-5.97,51.4-14.79,72.47-26.47v-113.06h-80.64v81.89c-5.84,2.26-11.75,4.16-17.71,5.7-16.53,4.25-33.51,6.37-50.94,6.37s-34.79-2.25-49.86-6.77c-15.08-4.51-28.16-10.75-39.23-18.71-11.09-7.96-19.62-17.45-25.61-28.46-5.99-11.01-8.99-22.89-8.99-35.63s3-25.34,8.99-36.23c5.99-10.88,14.52-20.3,25.61-28.26Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2402.83 112 2402.83 281.07 2213.21 112 2140.2 112 2140.2 390.67 2227.38 390.67 2227.38 221.61 2417 390.67 2490.01 390.67 2490.01 112 2402.83 112"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1243.36,
    y: 0.17,
    width: 21.46,
    height: 512
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexgen);
export default __webpack_public_path__ + "static/media/nexgen.2ec7e1d72baef7e358404a3704f52c23.svg";
export { ForwardRef as ReactComponent };